<template>
  <div>
    <inheritedList
        @closeParent="closeDetailPop"
        @openParent="openDetailPop"
        ref="inheritedList"
    ></inheritedList>
  </div>

</template>

<script>
import {formMixin, fmt, loadBaseCodeData} from '@/utils/common/FormBase'
//管理接口
import {dataApi} from '@/services/client/inherit.js';
import inheritedList from "./detail/inheritedList";
console.log(fmt,loadBaseCodeData)

/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {};
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {};
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  console.log('子表',rowId)
  await dataApi.getRecordSonTableList(rowId).then(item => {
    console.log('子数据',item)
    //子表赋值
    this.setRefsValue({
      inheritedList: item.data.list,
    })
  })
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
async function afterLoad(entity) {
  console.log(entity)
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities) {
  console.log(entities)
}

/**
 * 加载基础数据
 */
async function loadBaseData() {

}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    inheritedList
  },
  data() {
    return {
      sonListData:[]
    }
  },
  computed: {
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
    closeDetailPop(){
      this.$emit('closeParent')
    },
    openDetailPop(){
      this.$emit('openParent')
    },
  }
};
</script>

<style scoped lang="stylus">
/deep/ .vxe-toolbar {
  height 10px
}
</style>